import { useState } from "react";

type ImageAssetSpec = {
  mainImage?: string;
  alt?: string;
};

export function ImageAssetRenderer({ visualSpec }: { visualSpec: Record<string, unknown> }) {
  const spec = visualSpec as ImageAssetSpec;
  const [failed, setFailed] = useState(false);

  if (!spec.mainImage || failed) {
    return (
      <div className="w-full rounded-lg border border-amber-200/20 bg-amber-200/10 p-5 text-center text-sm text-slate-200">
        Η ερώτηση δεν μπορεί να εμφανιστεί σωστά.
      </div>
    );
  }

  return (
    <div className="flex w-full justify-center overflow-hidden rounded-lg border border-white/10 bg-slate-950/35 p-3 sm:p-4">
      <img
        src={spec.mainImage}
        alt={spec.alt ?? "Οπτική ερώτηση Brain Test"}
        className="max-h-[28rem] w-full max-w-3xl rounded-md object-contain"
        loading="eager"
        onError={() => setFailed(true)}
      />
    </div>
  );
}
